/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsPlatformAdminCreateInput } from "../../entities/models/PlatformAdminCreateInput";
import { z } from "zod/v4";

export const modelsPlatformAdminCreateInputSchema = z.object({
    "branch_id": z.optional(z.int()),
"company_id": z.int(),
"email": z.string(),
"name": z.string(),
"password": z.string().min(12).max(72),
"role": z.optional(z.enum(["company_admin", "branch_admin"]))
    }) as unknown as z.ZodType<ModelsPlatformAdminCreateInput>